import React, {
    createContext,
    ReactNode,
    useCallback,
    useContext,
    useMemo,
    useTransition,
} from 'react'

type AppTransitionContextType = {
    isTransitioning: boolean
    startTransition: (callback: () => void) => void
}

export const AppTransitionContext = createContext<AppTransitionContextType>({
    isTransitioning: false,
    startTransition: () => {
        // do nothing
    },
})

export const useAppTransition = () => useContext(AppTransitionContext)

export const AppTransitionProvider = ({ children }: { children: ReactNode }) => {
    const [isTransitioning, startTransition] = useTransition()

    const handleStartTransition = useCallback((callback: () => void) => {
        startTransition(callback)
    }, [])

    const value = useMemo(
        () => ({ isTransitioning, startTransition: handleStartTransition }),
        [isTransitioning, handleStartTransition],
    )

    return <AppTransitionContext.Provider value={value}>{children}</AppTransitionContext.Provider>
}
